<!-- 产品管理列表 -->
<template>
  <div>
    <div class="product-user">
      <div class="box-input">
        <div class="box-input-left">
          <el-select clearable v-model="productForm.countryId" @change="getQuery(1)" @focus="getCountrylist" placeholder="请选择国家" filterable remote :remote-method="remoteSearchCountry" :loading="countryLoading">
            <el-option v-for="item in (String(productForm.continentId) ? country : countryAll)" :key="item.id"
              :label="item.zhName" :value="item.id">
            </el-option>
          </el-select>
          <el-select v-model="productForm.isEnable" placeholder="是否上架" clearable filterable>
            <el-option label="全部" value=""> </el-option>
            <el-option label="已上架" value="true"> </el-option>
            <el-option label="未上架" value="false"> </el-option>
          </el-select>
          <el-input style="width: 200px;" v-model="productForm.name" placeholder="标题" clearable></el-input>
          <!-- <el-input style="width: 200px;margin-left:10px" v-model="productForm.subTitle" placeholder="副标题" clearable></el-input> -->

        </div>

        <div class="box-input-btn">
          <div>
            <el-button class="default" @click="searchFn(1)">搜索</el-button>
            <el-button class="box-input-btn-cz" @click="reset">重置</el-button>
            <el-button class="box-input-btn-cz" icon="el-icon-plus" @click="addProduct">添加</el-button>
          </div>
        </div>
      </div>


      <div class="box-table">
        <el-table :data="productList"
          :header-cell-style="{ backgroundColor: '#F2F4F7', color: '#333', fontWeight: 'bold', textAlign: 'center', fontSize: '12px' }"
          style="width: 100%" v-loading="loading" :height="$store.state.product.screen ? '820px' : '470px'"
          :cell-style="{ 'text-align': 'center' }" ref="refTable">
          <el-table-column prop="type" label="类型">
            <template slot-scope="scope">
              {{ scope.row.type == 1 ? '业务介绍' : '签证攻略' }}
            </template>
          </el-table-column>
          <el-table-column prop="title" label="标题">
          </el-table-column>
          <el-table-column prop="subTitle" label="副标题">
          </el-table-column>
          <el-table-column prop="countryName" label="国家">
          </el-table-column>
          <el-table-column prop="enable" label="是否上架" width="70px">
            <template slot-scope="scope">
              <div>
                <el-switch :value="scope.row.enable" active-color="#3888E9" inactive-color="#CCCCCC"
                  @change="switchChange(scope.row)">
                </el-switch>

              </div>
            </template>
          </el-table-column>
          <el-table-column prop="createdTime" label="发布时间"></el-table-column>
          <el-table-column label="操作" header-align="center">
            <template slot-scope="scope">
              <div class="edit-wrap">
                <div class="edit-item">
                  <span class="lan" @click="editProduct(scope.row)">编辑</span>
                  <span class="lan" @click="previewProduct(scope.row)">预览</span>
                  <span class="del" @click="delProduct(scope.row.id)">删除</span>
                </div>

              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="table-pagination">

        <el-pagination :page-sizes="[10, 20, 50, 100, 200, 500]" :current-page="pageIndex" :page-size="pageSize"
          @current-change="currentChange" @size-change="sizeChange" layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal">
        </el-pagination>
      </div>

    </div>

    <el-dialog :title="addForm.id ? '编辑产品' : '添加产品'" :visible.sync="addDialogVisible" width="900px" :close-on-click-modal="false" destroy-on-close>
      <el-form :model="addForm" label-width="80px" ref="addForm">
        <el-form-item label="类型" prop="type" v-if="!addForm.id" :rules="[{ required: true, message: '请选择类型', trigger: 'blur' }]">
          <el-select v-model="addForm.type" placeholder="请选择类型" filterable style="width: 100%;">
            <el-option label="签证攻略" value="0"> </el-option>
            <el-option label="业务介绍" value="1"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="国家" prop="countryId" :rules="[{ required: true, message: '请选择国家', trigger: 'blur' }]">
          <el-select v-model="addForm.countryId" placeholder="请选择国家" filterable style="width: 100%;">
            <el-option v-for="item in countryAll" :key="item.id" :label="item.zhName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title" :rules="[{ required: true, message: '请输入标题', trigger: 'blur' }]">
          <el-input v-model="addForm.title" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="副标题" prop="subTitle" :rules="[{ required: true, message: '请输入副标题', trigger: 'blur' }]">
          <el-input v-model="addForm.subTitle" placeholder="请输入副标题"></el-input>
        </el-form-item>
        <el-form-item label="产品内容" prop="content" :rules="[{ required: true, message: '请输入产品内容', trigger: 'blur' }]">
          <div style="border: 1px solid #D2D2D2;">
            <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor" :defaultConfig="toolbarConfig" :mode="mode" />
            <Editor style="height: 200px; overflow-y: hidden;" v-model="addForm.content" :defaultConfig="editorConfig" :mode="mode" @onCreated="onCreated" />
          </div>
        </el-form-item>
        <el-form-item label="是否启用">
          <el-switch v-model="addForm.enable" active-color="#3888E9" inactive-color="#CCCCCC"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitAddProduct">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="预览" :visible.sync="previewVisible" width="800px" :close-on-click-modal="false" class="preview-dialog">
      <div class="preview-content">
        <h3 class="preview-title">
          <div>标题：{{ previewData.title }}</div>
          <div>副标题：{{ previewData.subTitle }}</div>
        </h3>
        <div class="preview-body" v-html="previewData.content"></div>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import { query, visatypelist, arealist, countrylist, deleteProduct, visaenable, getcountrys, productCopy, visaiscard, add } from '@/api/personal.js'
import { productvisasort, exportexcel } from '@/api/product.js'
import { export_json_to_excel } from '@/utils/Export2Excel';
import alyoss from "@/utils/alyoss";
import { excelupdateprice } from "@/api/product.js";
import countrySystem from './countrySystem.vue'
import { queryvisacountryguide, addvisacountryguide, visacountryguidedetail, updatevisacountryguide, delvisacountryguide } from '@/api/org.js'

import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
export default {
  components: {
    countrySystem,
    Editor,
    Toolbar
  },
  data() {
    return {
      activeName: 'product',
      continent: [],
      visaType: [],
      area: [],
      countryAll: [],
      country: [],
      productList: [],
      countryData: [],
      productForm: {
        continentId: '',
        visaTypeId: '',
        countryId: '',
        areaId: '',
        name: '',
        subTitle: '',
        isEnable: 'true'
      },
      pageIndex: 1,
      pageSize: 10,
      pageTotal: 0,
      loading: false,
      countryLoading: false,
      importLoading: false,

      editInfo: {
        isShow: false,
        tabsName: 'first',
        productId: '',
        setting: {}
      },
      addDialogVisible: false,
      addForm: {
        id: '',
        countryId: '',
        title: '',
        subTitle: '',
        content: '',
        enable: true
      },
      editor: null,
      toolbarConfig: {
        "toolbarKeys": ["fontSize", "fontFamily", "bold", "underline", "through", "code", "sup", "sub", "clearStyle", "color",
          "bgColor", "lineHeight", "bulletedList", "numberedList", "justifyLeft", "justifyRight", "justifyCenter", "justifyJustify", "emotion", "indent",
          "delIndent", "todo", "uploadImage", "insertImage", "deleteImage", "uploadVideo", "insertVideo", "editVideoSize", "divider", "undo", "redo", "fullScreen"]
      },
      editorConfig: {
        placeholder: '请输入产品内容...',
        MENU_CONF: {
          uploadImage: {
            customUpload: async (file, insertFn) => {
              let that = this;
              try {
                let alyossData = await alyoss(file);
                let alt = file.name;
                insertFn(alyossData, alt)
              } catch (error) {
                console.log(error);
              }
            }
          },
          uploadVideo: {
            customUpload: async (file, insertFn) => {
              let that = this;
              try {
                let alyossData = await alyoss(file);
                insertFn(alyossData)
              } catch (error) {
                console.log(error);
              }
            }
          },
          insertVideo: {
            checkVideo: (url) => {
              const validExtensions = ['mp4', 'ogg', 'webm'];
              const videoLinkParts = url.split('.');
              const bool = validExtensions.includes(videoLinkParts[videoLinkParts.length - 1]);
              if (bool) {
                return true;
              } else {
                this.$message({
                  message: '请上传正确的视频链接',
                  type: 'warning'
                });
                return
              }
            }
          }
        }
      },
      mode: 'default',
      previewVisible: false,
      previewData: {
        title: '',
        subTitle: '',
        countryName: '',
        content: ''
      }

    }
  },
  porps: {
    init: {
      type: Boolean,
      default: false
    }
  },

  mounted() {
    this.continent = this.$store.state.product.countrys.continentCountry
    console.log(this.$store.state.product.screen);
    this.getQuery();
    this.getVisatypelist();

    // this.getArealist();
    this.getCountrylist();

    this.getcountrysFn();

    if (this.init) {
      this.continent = this.$store.state.countrys.continentCountry
      this.getQuery();
      this.getVisatypelist();

      // this.getArealist();
      // this.getCountrylist();
    }
  },
  methods: {
    fixImageSize(htmlContent) {
			if (!htmlContent) return ''
			return htmlContent.replace(/<img[^>]*>/gi, (match) => {
				if (match.indexOf('style=') !== -1) {
					return match.replace(/style="[^"]*"/gi, (styleMatch) => {
						return 'style="max-width:100%;width:100%;height:auto;' + styleMatch.slice(7, -1) + '"'
					})
				} else {
					return match.replace(/<img/gi, '<img style="max-width:100%;width:100%;height:auto;"')
				}
			})
		},
    getQuery(index) {
      this.pageIndex = index || this.pageIndex;
      this.loading = true;
      queryvisacountryguide({
        'Page.Size': this.pageSize,
        'Page.Index': this.pageIndex,
        CountryId: this.productForm.countryId || null,
        Enable: this.productForm.isEnable,
        Title: this.productForm.name,
        SubTitle: this.productForm.subTitle
      }).then(res => {
        console.log(res);
        this.loading = false;
        this.productList = res.data.rows
        this.pageTotal = res.data.total
      })
    },

    setProductCopy(id) {

      this.$confirm(`是否要复制该产品`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {


        productCopy({
          id
        }).then(res => {
          this.$message({
            message: '复制成功！',
            type: 'success'
          });
          this.getQuery();
        })


      }).catch(err => {

      })

      return;

    },

    reset() {
      this.productForm = {
        continentId: '',
        visaTypeId: '',
        countryId: '',
        areaId: '',
        name: '',
        subTitle: '',
        isEnable: 'true'
      }
      this.getQuery();
    },

    searchFn(index) {
      this.pageIndex = index;
      this.getQuery();
    },
    clearContinent(e) {

      this.country = []
      this.productForm.countryId = ''
      console.log(e);
    },
    getcountrysFn() {
      getcountrys().then(res => {

        this.countryData = res.data.continentCountry
      })
    },
    addProduct() {
      this.addForm = {
        id: '',
        countryId: '',
        title: '',
        subTitle: '',
        content: '',
        enable: true
      }
      this.addDialogVisible = true
    },
    onCreated(editor) {
      this.editor = Object.seal(editor)
    },
    submitAddProduct() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) {
          return
        }
        const params = {
        countryId: this.addForm.countryId,
        title: this.addForm.title,
        subTitle: this.addForm.subTitle,
        content: this.addForm.content,
        enable: this.addForm.enable,
        type: this.addForm.type
      }
      const apiFn = this.addForm.id ? updatevisacountryguide : addvisacountryguide
      if (this.addForm.id) {
        params.id = this.addForm.id
      }
      apiFn(params).then(res => {
        if (res.code == 1) {
          this.$message.success(this.addForm.id ? '编辑成功' : '添加成功')
          this.addDialogVisible = false
          this.getQuery()
        } else {
          this.$message.error(res.msg || (this.addForm.id ? '编辑失败' : '添加失败'))
        }
      })
      })
    },
    editProduct(item) {
      visacountryguidedetail({ id: item.id }).then(res => {
        if (res.code == 1) {
          const data = res.data
          this.addForm = {
            id: data.id,
            countryId: data.countryId,
            title: data.title,
            subTitle: data.subTitle,
            content: data.content,
            enable: data.enable,
            type: data.type
          }
          this.addDialogVisible = true
        } else {
          this.$message.error(res.msg || '获取详情失败')
        }
      })
    },
    editProduct2(item) {
      visacountryguidedetail({ id: item.id }).then(res => {
        if (res.code == 1) {
          const data = res.data
          this.addForm = {
            id: data.id,
            countryId: data.countryId,
            title: data.title,
            subTitle: data.subTitle,
            content: data.content,
            enable: data.enable
          }
          this.addDialogVisible = true
        } else {
          this.$message.error(res.msg || '获取详情失败')
        }
      })
    },
    previewProduct(item) {
      visacountryguidedetail({ id: item.id }).then(res => {
        if (res.code == 1) {
          const data = res.data
          this.previewData = {
            title: data.title,
            subTitle: data.subTitle,
            countryName: data.countryName,
            content: this.fixImageSize(data.content)
          }
          this.previewVisible = true
        } else {
          this.$message.error(res.msg || '获取详情失败')
        }
      })
    },

    toDataSettings(item) {
      this.$emit('openSettings', item);
    },

    delProduct(id) {
      this.$confirm(`是否要删除该产品`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delvisacountryguide({
          id: id
        }).then(res => {
          if (res.code == 1) {
            this.$message.success('删除成功')
            this.getQuery()
          } else {
            this.$message.error(res.msg || '删除失败')
          }
        }).catch(() => {})
      }).catch(err => {

      })
    },


    switchChange(item) {
      const newValue = !item.enable
      this.$confirm(`是否要${newValue ? '上架' : '下架'}该产品`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        updatevisacountryguide({
          countryId: item.countryId,
          title: item.title,
          subTitle: item.subTitle,
          content: item.content,
          id: item.id,
          enable: newValue
        }).then(res => {
          if (res.code == 1) {
            item.enable = newValue
            this.$message.success(newValue ? '上架成功' : '下架成功')
          } else {
            this.$message.error(res.msg || (newValue ? '上架失败' : '下架失败'))
          }
        }).catch(() => {})
      }).catch(() => {})
    },
    sortChange(row) {
      productvisasort({ "id": row.id, "sort": row.sort }).then(res => {
        if (res.code == 1) {
          this.getQuery();
        }
      })
    },

    // 签证大类
    getVisatypelist() {
      visatypelist({

      }).then(res => {
        console.log(res);
        this.visaType = res.data;
      })
    },
    // 领区
    // getArealist () {
    //     arealist({
    //          
    //     }).then(res => {
    //         console.log(res);
    //         this.area = res.data;
    //     })
    // },

    getCountrylist() {
      countrylist({

      }).then(res => {
        console.log(res);

        this.countryAll = res.data
      })
    },

    remoteSearchCountry(query) {
      if (query) {
        this.countryLoading = true;
        countrylist({
          key: query
        }).then(res => {
          this.countryAll = res.data || [];
          this.countryLoading = false;
        }).catch(() => {
          this.countryLoading = false;
        });
      } else {
        this.countryAll = [];
        this.getCountrylist();
      }
    },

    currentChange(val) {
      this.pageIndex = val;
      this.$refs.refTable.bodyWrapper.scrollTop = 0;
      this.getQuery();
    },
    sizeChange(val) {
      this.pageSize = val;
      this.$refs.refTable.bodyWrapper.scrollTop = 0;
      this.getQuery();
    },

  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy()
  }
}
</script>

<style lang="scss" scoped>
.product-user {
  // min-width: 973px;
  // width: 100%;
  height: 100%;

  ::v-deep {
    .el-select {
      margin-right: 8px;
    }

    .el-input__inner {
      background: #F2F4F7;
      border: none;
    }

    .el-table__row {
      .cell {
        font-size: 12px;
      }
    }
  }
}

.box-input-left {
  display: flex;

}

.box-table {
  // flex-grow: 1;
  // height: 100%;
  // display: flex;
  // flex-direction: column;
  // flex: 1;
}

.edit-wrap {

  .edit-item {
    // padding-left: 20px;


    span {
      cursor: pointer;
      display: inline-block;
      margin: 6px;

      &.lan {
        color: #3888E9;
      }

      &.copy {
        color: #9EA09E;
      }

      &.del {
        color: #E41313;
      }
    }
  }
}

.table-pagination {
  text-align: center;
  margin-top: 16px;
}

.box-input {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  width: 100%;

  .box-input-btn {
    text-align: right;

    .box-input-btn-cz {
      background: #EAF3FF;
      color: #3888E9;
      border: none;
    }

    .box-input-btn-add {
      background: #D8F5E4;
      color: #54D8A5;
      border: none;
    }
  }
}
</style>
<style scoped>
.preview-content {
  padding: 10px 0;
}
.preview-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}
.preview-country {
  font-size: 14px;
  color: #666;
  margin-bottom: 15px;
}
.preview-body {
  font-size: 14px;
  line-height: 1.8;
  color: #333;
  
  ::v-deep p {
    margin-bottom: 10px;
  }
  ::v-deep img {
    max-width: 100%;
    height: auto;
  }
  ::v-deep h1, ::v-deep h2, ::v-deep h3, ::v-deep h4, ::v-deep h5, ::v-deep h6 {
    font-weight: bold;
    margin-top: 15px;
    margin-bottom: 10px;
  }
  ::v-deep ul, ::v-deep ol {
    padding-left: 20px;
    margin-bottom: 10px;
  }
  ::v-deep li {
    margin-bottom: 5px;
  }
}
</style>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style>
.w-e-textarea-video-container {
    box-shadow: none !important;
}
.w-e-text-container .w-e-scroll .w-e-textarea-video-container {
    background: none !important;
    border: none !important;
}
.w-e-full-screen-container {
    z-index: 2000 !important;
    top: 76px !important;
}
.preview-dialog{
   .el-dialog__body{
    padding: 0 20px;
  }
}
</style>